import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  contractStatusIcon : {
    width: "3rem",
    height: "3rem",
    position: "relative",
    top: "0.2rem",
    margin : "auto"
  },
  statusIcon : {
    width: "1.5rem",
    height: "1.5rem",
    position: "relative",
    top: "0.2rem",
    margin : "auto"
  },
  tableTitleHeader:{
    display : "flex",
    width : "100%",
    justifyContent : "space-between",
    paddingBottom : "0.7em"
  },
  tableTitle:{
    color : "#336e5e",
    marginTop: "auto"
  },
  button: {
    
    marginTop: 10,
    marginLeft: 5,
    backgroundColor: "#ffffff",
    color: "#1e453b",
    border: "1px solid #1e453b",
    borderRadius : 2,
    "&:hover": {
      backgroundColor: "#1e453b",
      color: "#ffffff"
    }
  },
  tableHeaderCell:{
    backgroundColor : "#336e5e",
    color : "#ffffff"
  },
  tableRow:{
    cursor : "pointer"
  },
  contractStatusContainer:{
    display :"flex",
    flexWrap : "wrap"

  },
  contractStatusElement:{
    display :"flex",
    flexDirection : "column",
    flexBasis : "15%",
    alignItems  : "center",
    marginBottom : "2px",
    marginRight : "2px",
    border : "1px solid #f0f0f0",
    borderRadius : "2px"

  },
  contractStatusLabel:{
    display : "inline-flex",
    paddingBottom: "7px",
    paddingTop: "3px",
    width : "100%",
    backgroundColor : "#f0f0f0"
  },
  contractStatusValue:{
    display : "inline-flex",
    paddingTop: "3px",
    paddingBottom: "7px",
    width : "100%",
    borderTop: "1px solid #f0f0f0"
  },
  tabLogos:{
    width : "30px",
    height : "25px",
    margin : "auto"
  }
}));

export default useStyles;
